export const mapboxConfig = {
  accessToken: 'pk.eyJ1Ijoia2F0aWVmdWppaGFyYSIsImEiOiJjamZsdnM1cDQwbXBsMnFxbzcwNzdscGE2In0.TX5_xN0gckWco-bvSENNeg'
}



// WEBPACK FOOTER //
// /Users/kaitlynfujihara/Desktop/keiken/src/local/mapbox.config.ts